import { useParams, useSearchParams } from "react-router-dom";

import { ErrorMessage } from "@/app/components/error-message";
import { LoadingScreen } from "@/components/loading-screen";
import { SearchBar } from "@/components/search-bar";
import { useTableControl } from "@/components/table-control";
import { OnboardingHeader } from "@/features/registration/components/onboarding-header";
import { SessionsTable } from "@/features/session/components/sessions-table";
import { useGetSessionsByOrg } from "@/features/sessions/api/get-sessions-by-org";
import { keepPreviousData } from "@tanstack/react-query";

export function OrganisationSessionsPage() {
  const { id: organisationId } = useParams();
  const { pagination, setPagination, search, setSearch } = useTableControl();
  const [searchParams] = useSearchParams();

  const {
    data: sessions,
    isLoading,
    isSuccess,
    isFetching,
    isError,
    isPlaceholderData,
    error,
  } = useGetSessionsByOrg(
    {
      pageSize: pagination.pageSize,
      pageIndex: pagination.pageIndex,
      search: search ?? undefined,
      organisationId: organisationId ?? "",
      day: searchParams.get("day") ?? undefined,
    },
    { placeholderData: keepPreviousData },
  );

  if (isLoading) {
    return (
      <section>
        <OnboardingHeader
          title="Sessions"
          description="View Organisation sessions"
          className="mb-6"
        />
        <LoadingScreen />
      </section>
    );
  }

  if (isError || !isSuccess) {
    return (
      <div>
        <OnboardingHeader
          title="Manage Users"
          description="View and manage users"
          className="mb-6"
        />
        <ErrorMessage error={error} />
      </div>
    );
  }

  return (
    <section>
      <OnboardingHeader
        title="Sessions"
        description="View Organisation sessions"
        className="mb-6"
      />
      <SearchBar search={search} setSearch={setSearch} className="mb-4" />

      <SessionsTable
        data={sessions.items}
        pagination={pagination}
        pageCount={Math.ceil(sessions.count / pagination.pageSize)}
        onPaginationChange={setPagination}
        isLoading={isFetching && isPlaceholderData}
      />
    </section>
  );
}
